import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import HeaderComponent from "../components/HeaderComponent";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import CreditCard from "../components/CreditCard";
import countryCodes from "../components/countryCodes.json";
import Language from "../languages";
import Services from "../services/Services";

export default function PaymentPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const item = location.state; // ödeme yapılacak öğeler dizisi
  const uri = localStorage.getItem("mallUri");
  const storedMall = localStorage.getItem("mall");
  const _mall = useSelector((state) => state.mall);
  const language = useSelector((state) => state.language);

  const [token, setToken] = useState("");
  const [EPToken, setEPToken] = useState("");
  const [paymentToken, setPaymentToken] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [cvv, setCvv] = useState("");
  const [countries, setCountries] = useState([]);
  const [htmlContent, setHtmlContent] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [conversationID, setConversationID] = useState("");
  const [customer, setCustomer] = useState({});
  const [cardError, setCardError] = useState("");

  // ✅ Yeni: EP Prod token + mall accountCode
  const [EPProdToken, setEPProdToken] = useState("");
  const [mallAccountCode, setMallAccountCode] = useState("");

  // Modal alert durumları
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorModalMessage, setErrorModalMessage] = useState("");

  useEffect(() => {
    setCountries(countryCodes);
    const userToken = localStorage.getItem("token");
    setToken(userToken);
    const phone = localStorage.getItem("phone");
    const email = localStorage.getItem("email");

    let getCustomerBy = email ? "email" : "phone";
    let getCustomerByValue = email ? email : phone;

    Services.GetCustomer(userToken, getCustomerBy, getCustomerByValue)
      .then((res) => {
        if (res.data.status) {
          const customerData = res.data.result;
          setCustomer({
            name: customerData.name,
            lastname: customerData.lastname,
            phone: customerData.phone,
            email: customerData.email,
          });
          setCustomerId(customerData.customerID);
          setFirstName(customerData.name);
          setLastName(customerData.lastname);
        } else {
          console.log("GetCustomer servisi çalışmadı.");
          setCustomer(null);
        }
      })
      .catch((err) => {
        setCustomer(null);
        console.log(err);
      });
  }, []);

  // ödeme tokenları
  useEffect(() => {
    console.log("item: ", item);

    Services.GetTokenForPayment()
      .then((res) => {
        if (res.data && res.data.result.token) {
          setPaymentToken(res.data.result.token);
        } else {
          console.error("GetTokenForPayment token alınamadı.");
        }
      })
      .catch((err) => {
        console.error("GetTokenForPayment hatası:", err);
      });

    Services.GetEPToken()
      .then((res) => {
        if (res.data && res.data.result.token) {
          setEPToken(res.data.result.token);
        } else {
          console.error("GetEPToken token alınamadı.");
        }
      })
      .catch((err) => {
        console.error("GetEPToken hatası:", err);
      });
  }, []);

  // ✅ Yeni: Sayfa açılır açılmaz EP Prod Token al -> GetMall çağır -> accountCode al
  useEffect(() => {
    const run = async () => {
      try {
        const mallInfo = storedMall ? JSON.parse(storedMall)[0] : null;
        const mallId = mallInfo?.id || mallInfo?.mallID || mallInfo?.mallId;

        if (!mallId) {
          console.log("Mall id bulunamadı (storedMall).");
          return;
        }

        const prodTokenRes = await Services.GetEPProdToken();
        const prodToken = prodTokenRes?.data?.result?.token;

        if (!prodToken) {
          console.log("GetEPProdToken: token alınamadı", prodTokenRes?.data);
          return;
        }
        console.log("prodToken: ", prodToken);
        setEPProdToken(prodToken);

        const mallRes = await Services.GetMall(prodToken, mallId);
        const accountCode = mallRes?.data?.result?.accountCode;
        console.log("accountCode: ", accountCode);
        if (!accountCode) {
          return;
        }

        setMallAccountCode(accountCode);
      } catch (err) {}
    };

    run();
  }, [storedMall]);

  const handleExpiryDateChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length >= 2) {
      let month = value.slice(0, 2);
      if (parseInt(month, 10) > 12) {
        month = "12";
      }
      value = month + (value.length > 2 ? `/${value.slice(2, 4)}` : "");
    }
    setExpiryDate(value);
  };

  const isFutureDate = (date) => {
    const [month, year] = date.split("/").map((num) => parseInt(num, 10));
    const today = new Date();
    const expiry = new Date(`20${year}`, month - 1);
    return expiry > today;
  };

  // Luhn algoritması
  const isValidCardNumber = (number) => {
    let sum = 0;
    let shouldDouble = false;
    for (let i = number.length - 1; i >= 0; i--) {
      let digit = parseInt(number.charAt(i), 10);
      if (shouldDouble) {
        digit *= 2;
        if (digit > 9) {
          digit -= 9;
        }
      }
      sum += digit;
      shouldDouble = !shouldDouble;
    }
    return sum % 10 === 0;
  };

  const isFormComplete =
    firstName &&
    lastName &&
    cardNumber.length >= 15 &&
    expiryDate &&
    cvv &&
    isFutureDate(expiryDate);

  // Service / per-package fiyat bilgisi hesaplayıcı
  const getPriceInfo = () => {
    const mallInfo = JSON.parse(storedMall)[0];
    const rawPrice = Number(item[0]?.deliveryTypeInfo?.price || 0);
    const calculationUnit = mallInfo.calculationUnit; // "service" veya "per-package"

    let unit = "";
    let quantity = 0;
    let unitPrice = 0;
    let totalPrice = 0;

    if (calculationUnit === "service") {
      unit = "service";
      quantity = 1;
      unitPrice = rawPrice;
      totalPrice = rawPrice;
    } else if (calculationUnit === "per-package") {
      unit = "per-package";
      const pkgCount = Number(
        item[0]?.ordersTotalPackageCount || item.length || 0,
      );
      quantity = pkgCount;
      unitPrice = rawPrice;
      totalPrice = unitPrice * quantity;
    }

    return { unit, quantity, unitPrice, totalPrice };
  };

  const buildInvoiceData = () => {
    const mallInfo = JSON.parse(storedMall)[0];
    const { unit, quantity, unitPrice, totalPrice } = getPriceInfo();

    const now = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    const dateStr = `${pad(now.getDate())}.${pad(
      now.getMonth() + 1,
    )}.${now.getFullYear()} ${pad(now.getHours())}:${pad(now.getMinutes())}`;

    const mallTitleFromItem = item[0]?.mallTitle;
    const mallTitle = mallTitleFromItem || mallInfo.title || "";

    return {
      customer: {
        name: customer?.name || "",
        lastname: customer?.lastname || "",
        uID: customerId || "",
        isCorporational: false,
      },
      order: {
        id: item[0]?.orderID || "",
        stockCode: "HDF001",
        assignedLocation: mallAccountCode || mallInfo.prefix,
        projectLocation: mallInfo.id,
        projectTitle: "EASY POİNT-HANDS FREE",
        projectCode: "02.09",
        deliveryType: "New",
        barcode: item[0]?.orderID || "",
        quantity: quantity,
        unit: unit,
        unitPrice: unitPrice,
        subTotal: totalPrice,
        total: totalPrice,
        currency: "TRY",
        sku: "HDF001",
        title: `Lokasyon: ${mallTitle} - Tarih: ${dateStr} - Handsfree Id ${item[0]?.orderID}`,
        taxRate: 20,
        options: {
          size: "M",
        },
      },
      billing: {
        id: conversationID,
        paymentID: conversationID,
        street: "",
        neighbour: "",
        region: mallInfo.town,
        city: mallInfo.city,
        country: "Türkiye",
        phone: customer?.phone || "",
        address: "",
        title: mallInfo.title,
        taxNo: "0",
        taxAdministration: "----",
        email: customer?.email || "",
        uID: customer?.phone || "",
      },
    };
  };

  const handleSubmit = () => {
    if (!isValidCardNumber(cardNumber)) {
      setCardError(Language(_mall, language, "invalidCreditCard"));
      return;
    }
    setCardError("");
    setLoading(true);

    const convID = `HDF-${Date.now()}${customerId}`;
    setConversationID(convID);

    const [expMonth, expYear] = expiryDate.split("/");
    const creditCardInfos = {
      holderName: `${firstName.trim()} ${lastName.trim()}`,
      cardNumber: cardNumber,
      expMonth: expMonth,
      expYear: expYear,
      cvc: cvv,
    };

    const { totalPrice } = getPriceInfo();

    const itemsArray = [
      {
        name: `${item.length} adet Handsfree Paketi`,
        price: totalPrice,
      },
    ];

    Services.Payment(
      paymentToken,
      convID,
      totalPrice,
      customer,
      creditCardInfos,
      itemsArray,
    )
      .then((res) => {
        console.log("Payment response:", res.data);
        if (res.data.status) {
          setHtmlContent(res.data.result);
        } else {
          console.log("Ödeme servisi çalışmadı.");
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  // Ödeme kontrolü
  useEffect(() => {
    if (conversationID) {
      const interval = setInterval(() => {
        Services.CheckPayment(paymentToken, conversationID)
          .then((res) => {
            console.log("CheckPayment response:", res.data);
            const status = res.data.result;

            if (status === "1") {
              const runAfterSuccess = async () => {
                try {
                  const promises = item.map((itm) =>
                    Services.SetPaid(
                      token,
                      conversationID,
                      "online",
                      itm?.postID,
                    ),
                  );
                  await Promise.all(promises);

                  try {
                    const invoice = buildInvoiceData();
                    console.log("invoice data: ", invoice);
                    if (EPToken && invoice) {
                      const invRes = await Services.AddInvoice(
                        EPToken,
                        invoice,
                      );
                      console.log("AddInvoice response:", invRes.data);
                    } else {
                      console.log(
                        "EPToken veya invoice yok, AddInvoice atlandı.",
                        {
                          EPToken,
                          invoice,
                        },
                      );
                    }
                  } catch (invErr) {
                    console.error("AddInvoice hatası:", invErr);
                  }

                  navigate("/payment-final", { state: item });
                } catch (error) {
                  console.error("SetPaid / AddInvoice sırasında hata:", error);
                } finally {
                  clearInterval(interval);
                }
              };

              runAfterSuccess();
            } else if (status === "2") {
              Services.GetErrorPayment(paymentToken, conversationID)
                .then((errorRes) => {
                  console.log("Error Payment response:", errorRes.data);
                  setErrorModalMessage(
                    errorRes.data?.result?.errors?.errorDescription
                      ? errorRes.data?.result?.errors?.errorDescription
                      : "Bir hata oluştu, tekrar deneyiniz.",
                  );
                  setErrorModalOpen(true);
                })
                .catch((err) => console.error("Error Payment hatası:", err));
              console.log("Ödeme iptal edildi.");
              clearInterval(interval);
              setHtmlContent(null);
            } else if (status === "3") {
              console.log("Ödeme beklemede...");
            } else if (status === "4") {
              console.log("3D doğrulama gerekli, beklemede...");
            } else {
              clearInterval(interval);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [
    conversationID,
    paymentToken,
    token,
    item,
    navigate,
    EPToken,
    customerId,
    mallAccountCode,
  ]);

  return (
    <Container>
      <Box sx={{ my: 4, mx: 2 }}>
        <HeaderComponent
          middle="logo"
          goBack={() => navigate(`/${localStorage.getItem("mallUri")}`)}
          left="back"
          right="icon"
        />
        <Box sx={{ marginTop: 2 }}>
          <Box>
            <Typography component="span" sx={{ color: "#1F2A37" }}>
              Easy Point{" "}
            </Typography>
            <Typography
              component="span"
              sx={{ fontWeight: "bolder", color: "#1F2A37" }}
            >
              Hands Free
            </Typography>
            <Divider sx={{ backgroundColor: "#EAEAEA", my: 1 }} />
          </Box>

          {htmlContent ? (
            <iframe
              srcDoc={htmlContent}
              style={{
                width: "100vw",
                height: "100vh",
                border: "none",
                position: "fixed",
                top: 60,
                left: 0,
                zIndex: 9999,
              }}
              title="Payment Content"
            />
          ) : (
            <div
              style={{
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                marginTop: 30,
              }}
            >
              <CreditCard
                cardNumber={cardNumber}
                cardHolder={`${firstName} ${lastName}`}
                expiryDate={expiryDate}
              />
            </div>
          )}

          {!htmlContent && (
            <Box component="form" sx={{ mt: 3 }}>
              <TextField
                fullWidth
                label={Language(_mall, language, "cardHolderName")}
                variant="outlined"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                label={Language(_mall, language, "cardHolderLastname")}
                variant="outlined"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                label={Language(_mall, language, "cardNumber")}
                variant="outlined"
                value={cardNumber}
                inputProps={{ maxLength: 16 }}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  setCardNumber(value);
                  if (cardError) setCardError("");
                }}
                sx={{ mb: 2 }}
              />
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
              >
                <TextField
                  label={Language(_mall, language, "expiryDate")}
                  variant="outlined"
                  value={expiryDate}
                  onChange={handleExpiryDateChange}
                  inputProps={{ maxLength: 5 }}
                  sx={{ flex: 1, mr: 1 }}
                />
                <TextField
                  label="CVV"
                  variant="outlined"
                  value={cvv}
                  inputProps={{ maxLength: 4 }}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setCvv(value);
                  }}
                  sx={{ flex: 1, ml: 1 }}
                />
              </Box>
              <Button
                disabled={!isFormComplete || loading}
                fullWidth
                variant="contained"
                color="newRed"
                startIcon={<i className="fa fa-credit-card" />}
                onClick={handleSubmit}
              >
                {loading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  Language(_mall, language, "proceedToPayment")
                )}
              </Button>
              {cardError && (
                <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                  {cardError}
                </Typography>
              )}
            </Box>
          )}
        </Box>
      </Box>

      <Dialog open={errorModalOpen} onClose={() => setErrorModalOpen(false)}>
        <DialogTitle>Ödeme Hatası</DialogTitle>
        <DialogContent>
          <Typography>{errorModalMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setErrorModalOpen(false)}>Tamam</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
